export default __webpack_public_path__ + "static/media/default-avatar.f8b384b5.svg";